import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'

import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import React from 'react'
import { Document, Page, pdfjs } from 'react-pdf'

import styles from './PdfViewer.module.scss'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const PdfViewer = ({ url, className, width }) => {
  const [numPages, setNumPages] = React.useState(null)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  return (
    <div className={className}>
      <Document
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<LoadingIndicator white />}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <>
            <div className={styles.page}>
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={width}
                className={styles.page}
              />
            </div>
            {index !== numPages - 1 && <div style={{ height: 20 }} />}
          </>
        ))}
      </Document>
    </div>
  )
}

export default PdfViewer
